'use client';

import dynamic from 'next/dynamic';

// Dynamically import the real client gallery with ssr disabled (client-only)
const ClientGallery = dynamic(() => import('./clientGallery'), { ssr: false });

export default function ClientGalleryWrapper(props) {
    return <ClientGallery {...props} />;
}
